import validator from 'validator'
import { t } from 'i18next'

interface Props {
  errorMsg?: string
  maxLength?: number
}
export const required = (value: any, props: Props) => {
  if (!value.toString().trim().length) {
    // We can return string or jsx as the 'error' prop for the validated Component

    if (props && props.errorMsg) {
      return props.errorMsg
    } else {
      return 'Required.'
    }
  }
}

export const requiredSelected = (data: any, props: Props) => {
  if (!data) {
    // We can return string or jsx as the 'error' prop for the validated Component

    if (props && props.errorMsg) {
      return props.errorMsg
    } else {
      return 'Required.'
    }
  }
}

export const email = (value) => {
  if (value !== null && value.toString().trim().length > 0 && !validator.isEmail(value)) {
    return 'Your email pattern is not valid.'
  }
}

export const lt = (value, props: Props) => {
  // get the maxLength from component's props
  if (props?.maxLength && !(value.toString().trim().length > props.maxLength)) {
    // Return jsx
    return `The value exceeded ${props.maxLength} symbols.`
  }
}

// Thai Telephone
//   home: 02-123-1234 => ( 9 numbers, start with 02, 03, 04, 05 and 07)
//   mobile: 081-123-1234 => ( 10 numbers, start with 06, 08 and 09)
export const phoneThai = (value) => {
  if (!/^0([23457][0-9]{7}|[689][0-9]{8})$/.test(value)) {
    return t('form.input.tel.invalids.pattern')
  }
}
export const phone = (value) => {
  if (!/^(0[0-9]{8,9})$/.test(value)) {
    return t('form.input.tel.invalids.pattern')
  }
}
export const number = (value) => {
  if (!validator.isInt(value)) {
    return 'ตัวเลขเท่านั้น'
  }
}
export const identityNumber = (value) => {
  if (!validator.isLength(value, { min: 13, max: 13 })) {
    return 'เลขบัตรประชาชน 13 หลักเท่านั้น'
  }
}

export const letterOrNumber = (value) => {
  const re = /^([\wก-๙/]+\s?)*\s*$/
  if (!re.test(value)) {
    return 'ตัวเลข 0-9, A-Z, ก-ฮ, / และ ช่องว่าง เท่านั้น'
  }
}

export const roomIdPattern = (value) => {
  if (value.indexOf('#') === -1) {
    return 'กรุณาระบุเครื่องหมาย # อย่างน้อย 1 ตัว'
  }
}

export const letterOrNumberRoomPattern = (value) => {
  const re = /^([\wก-๙/@#]+\s?)*\s*$/
  if (!re.test(value)) {
    return 'ตัวเลข 0-9, A-Z, ก-ฮ, เครื่องหมาย / @ # และ ช่องว่าง เท่านั้น'
  }
}

export const numberNotZero = (value) => {
  if (!validator.isInt(value) || value < 1) {
    return 'ใส่จำนวนที่มากกว่า 0 เท่านั้น'
  }
}

export const numberNotMinus = (value) => {
  if (!validator.isInt(value) || value < 0) {
    return 'ใส่จำนวนตั้งแต่ 0 ขึ้นไปเท่านั้น'
  }
}

export const password = (value, props, components) => {
  // NOTE: Tricky place. The 'value' argument is always current component's value.
  // So in case we're 'changing' let's say 'password' component - we'll compare it's value with 'confirm' value.
  // But if we're changing 'confirm' component - the condition will always be true
  // If we need to always compare own values - replace 'value' with components.password[0].value and make some magic with error rendering.
  if (
    value !== components['confirm'][0].value &&
    components['confirm'][0].value.length > 0 &&
    components['confirm'][0].isUsed
  ) {
    // components['password'][0].value !== components['confirm'][0].value
    // 'confirm' - name of input
    // components['confirm'] - array of same-name components because of checkboxes and radios
    return true
  }
}

export const confirmPassword = (value, props, components) => {
  // NOTE: Tricky place. The 'value' argument is always current component's value.
  // So in case we're 'changing' let's say 'password' component - we'll compare it's value with 'confirm' value.
  // But if we're changing 'confirm' component - the condition will always be true
  // If we need to always compare own values - replace 'value' with components.password[0].value and make some magic with error rendering.
  if (value !== components['password'][0].value) {
    // components['password'][0].value !== components['confirm'][0].value
    // 'confirm' - name of input
    // components['confirm'] - array of same-name components because of checkboxes and radios
    return 'Your re-password is not match'
  }
}
export const getErrorMessage = (ref: { [key: string]: any }) => {
  // console.log('ref.state.byId', ref.state.byId)
  const formArray = Object.values(ref.state.byId) as any
  let errorMessage = ''
  formArray.reverse().map((fa) => {
    if (fa.error) {
      if (fa.error !== true) {
        errorMessage = fa.error
      }
    }
    return fa
  })
  return errorMessage !== '' ? errorMessage : false
}

export const clearErrorMessage = (ref: { [key: string]: any }) => {
  const formArray = Object.values(ref.state.byId) as any
  formArray.map((fa) => {
    fa.isCheckable = false
    fa.isUsed = false
    fa.isChanged = false
    return fa
  })
}

export const checkLegacyId = (legacyId: string) => {
  const startNumber = ['110', '010', '020']
  const checkStartId = startNumber.some((id) => legacyId.startsWith(id))
  return checkStartId && legacyId.length === 9
}

export const validateLegacyId = (legacyId: string) => {
  if (!checkLegacyId(legacyId)) {
    return 'กรุณาระบุเลขสมาชิกเก่าของท่านให้ถูกต้อง'
  }
}
